import { Spinner } from "../../../components/Spinner";
import { useLazyDashboardQuery } from "../../../services/docs";
import { useForm } from "../../../hooks/useForm";
import { toastr } from "react-redux-toastr";
import { DashboardComponent } from "../../../components/DashboardComponet";
import { useEffect, useState } from "react";
import { fecha_mes } from "../../../hooks/elapsed";
import { useSocket } from "../../../hooks/Websocket";

export const DashboardScreen = () => {
  const { socket, isConnected } = useSocket();
  const [getEquipo, { data, isLoading }] = useLazyDashboardQuery();
  const [llamadasActivas, setLlamadasActivas] = useState<any[]>([]);
  const { formulario, handleInputChange, handleSelectChange } = useForm({
    user_id: "",
    accion: "",
  });
  useEffect(() => {
    getEquipo();
  }, []);
  useEffect(() => {
    console.log("s", socket);
    if (!socket) return;
    socket.emit("unirse_dashboard");

    const handleNuevaLlamada = (nuevaLlamada: any) => {
      console.log("Nueva llamada recibida:", nuevaLlamada);
      setLlamadasActivas((prev) => [...prev, nuevaLlamada]);
    };

    const handleFinLlamada = (llamadaFinalizada: any) => {
      console.log("Llamada finalizada:", llamadaFinalizada);
      setLlamadasActivas((prev) =>
        prev.filter((call) => call.id !== llamadaFinalizada.id)
      );
    };
    socket.on("dashboard_update_inicio", handleNuevaLlamada);
    socket.on("dashboard_update_fin", handleFinLlamada);
    return () => {
      socket.off("dashboard_update_inicio", handleNuevaLlamada);
      socket.off("dashboard_update_fin", handleFinLlamada);
    };
  }, [socket]);

  if (isLoading) {
    return (
      <div className="flex w-full justify-center">
        <Spinner />
      </div>
    );
  }
  return (
    <>
      <div className="card rounded-2xl">
        <div className="w-full text-left">
          <h1 className="text-1xl text-center font-bold">{fecha_mes()}</h1>
        </div>
      </div>
      <div className="xs:grid-cols-2 mt-10 grid grid-cols-4 place-items-stretch gap-4 md:grid-cols-2 lg:grid-cols-3 ">
        {isLoading && (
          <div className="flex w-full justify-center">
            <Spinner />
          </div>
        )}
        {!isLoading && data && data.equipo && data.equipo.length === 0 && (
          <div className="my-4 rounded bg-primary py-2 text-center text-white">
            No se encontraron datos
          </div>
        )}
        {!isLoading && data && data.llamadas && data.llamadas.length > 0 && (
          <DashboardComponent data={data.llamadas} />
        )}
      </div>
    </>
  );
};
